import { ContentTechnicalPhotoItemType, ContentTechnicalType, PhotoSizeType } from '@features/productPreview/sections/ProductDescription/typescript';
export const getImage = (items: ContentTechnicalPhotoItemType, key: PhotoSizeType) => items.sizes[key];
export const getDimensions = (content: string): Array<ContentTechnicalType> => {
  try {
    return JSON.parse(content);
  } catch {
    return [];
  }
};